<template>
  <v-card class="align-center justify-center text-center" :disabled="disabled">
    <v-card-text class="ma-0 pa-1">
      <v-row class="justify-center align-center">
        <v-col
          cols="12"
          md="6"
          sm="6"
          class="d-flex flex-column justify-center align-center"
        >
          <div class="overline primary--text pr-1">
            {{ localValue.identifier }}
          </div>
          <v-switch
            v-model="isConstant"
            @change="updateIsConstant"
            :label="$t('formula.form.isConstant')"
          />
        </v-col>
        <v-col v-if="isConstant" cols="12" md="6" sm="6">
          <v-autocomplete
            v-model="localValue.constantId"
            :items="constants"
            :label="$t('formula.form.constants')"
            item-text="name"
            item-value="constantId"
            dense
            prepend-icon="mdi-plus-circle-outline"
            @click:prepend="newConstant"
          >
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title v-html="data.item.name" />
                <v-list-item-subtitle v-html="data.item.value" />
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col v-else cols="12" md="6" sm="6">
          <v-autocomplete
            v-model="localValue.deveui"
            :items="selectableTags"
            :label="$t('formula.form.tags')"
            item-text="name"
            item-value="deveui"
            dense
            :filter="tagFilter"
          >
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title v-html="data.item.name" />
                <v-list-item-subtitle v-html="data.item.deveui" />
              </v-list-item-content>
            </template>
          </v-autocomplete>
          <v-autocomplete
            v-model="localValue.key"
            :items="selectableKeys"
            :label="$t('formula.form.keys')"
            item-text="label"
            item-value="key"
            dense
          >
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title v-html="data.item.label" />
                <v-list-item-subtitle v-html="data.item.key" />
              </v-list-item-content>
            </template>
          </v-autocomplete>
          <v-switch
            class="ma-0"
            v-if="!awaiting"
            v-model="localValue.triggerOnChange"
            :label="$t('formula.form.triggerOnChange')"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { autoCompleteTagFilter } from "@/_helpers/commonHelper";

export default {
  name: "FormulaResourceForm",

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },

    awaiting: {
      type: Boolean,
      default: false,
    },

    selectableTags: {
      type: Array,
      default: () => [],
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  model: {
    prop: "value",
  },

  data() {
    return {
      isConstant: false,
      selectableKeys: [],
      localSelectedDeveui: "",
    };
  },

  computed: {
    ...mapState("formulas", ["constants"]),

    localValue: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    ...mapActions("tag", ["getKeysForTag"]),

    tagFilter(item, queryText) {
      return autoCompleteTagFilter(item, queryText);
    },

    async loadKeys(deveui) {
      this.selectableKeys = (await this.getKeysForTag({ tagId: deveui })) ?? [];
    },

    updateIsConstant(value) {
      if (this.disabled) return;
      this.isConstant = value;
      if (!value) {
        this.localValue.constantId = null;
        return;
      }
      this.localValue.deveui = null;
      this.localValue.key = null;
      this.selectableKeys = [];
    },

    async newConstant() {
      this.$emit("newConstant");
    },
  },

  async created() {
    if (this.localValue.deveui) {
      await this.loadKeys(this.localValue.deveui);
      this.localSelectedDeveui = this.localValue.deveui;
    }
    if (this.localValue.constantId) this.isConstant = true;
  },

  watch: {
    value: {
      handler(val) {
        if (val.deveui && val.deveui != this.localSelectedDeveui) {
          this.updateIsConstant(false);

          this.loadKeys(val.deveui);
          this.localSelectedDeveui = val.deveui;
          return;
        }
        if (val.constantId && !this.isConstant) {
          this.updateIsConstant(true);
        }
      },
      deep: true,
    },
  },
};
</script>
